import React from 'react'
import { Layout } from 'antd'
import classnames from 'classnames'
import AppRoutes from './routes'
import { AuthContextProvider } from 'contexts/AuthContext'
import { FeatureFlagProvider } from 'contexts/FeatureFlagContext'
import './App.scss'
import withRouter from 'hooks/withRouter'
const { Content } = Layout

const App = (props) => {
  return (
    <FeatureFlagProvider>
      <Layout className={classnames('styles')}>
        <Content className={classnames('main')}>
          <AppRoutes />
        </Content>
      </Layout>
    </FeatureFlagProvider>
  )
}

export default withRouter(AuthContextProvider(App))
